export default (string, int) => {
    if (int > 1) {
        return `${string}s`;
    }

    return string;
};
